export default "__VITE_ASSET__Dte35TL1__"